import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import {
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography
} from "@mui/material";
import moment from "moment-timezone";
import { useTranslation } from "react-i18next";
import { useI18nLanguage } from "../../hooks/i18nLanguage";
import { UseBookingFormReturnType } from "../../hooks/useBookingForm";
import { SchedulerStoreType } from "../../state/scheduler.store";
import { BookingFormWrapper } from "../Forms/BookingFormWrapper";

interface MeetingDetailsDialogProps {
  open: boolean;
  onClose: () => void;
  currentlySelectedSlot: string | null;
  meetingLink: SchedulerStoreType["meetingLink"];
  sessionData: SchedulerStoreType["sessionData"];
  handleFormInput: UseBookingFormReturnType["handleFormInput"];
  actions: SchedulerStoreType["actions"];
  ui: SchedulerStoreType["ui"];
  themeVariant: "light" | "dark";
}

export const MeetingDetailsDialog = ({
  open,
  onClose,
  currentlySelectedSlot,
  meetingLink,
  sessionData,
  handleFormInput,
  actions,
  ui,
  themeVariant
}: MeetingDetailsDialogProps) => {
  const { t } = useTranslation();
  const { selectedLanguageForMoment } = useI18nLanguage();

  return (
    <Dialog
      onClose={onClose}
      open={open}
      sx={{
        backdropFilter: "blur(2px)",
        "& .MuiPaper-root": {
          background: themeVariant === "dark" ? "#121212" : "white",
          borderRadius: "5px",
          border:
            themeVariant === "dark" ? "1px solid #262626" : "1px solid white"
        }
      }}
      fullWidth
    >
      <DialogTitle sx={{ my: 0, pb: 0, px: 4 }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography fontSize={19} fontWeight={500}>
            {t("ROOSTER.PUBLIC-APP.CONFIRM_MEETING_DETAILS", {
              defaultValue: "Confirm your meeting details"
            })}
          </Typography>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ mt: 1, px: 4 }}>
        <Stack direction="row" spacing={2} alignItems="center" mb={3}>
          <AccessTimeOutlinedIcon />
          <Stack direction="row" gap={2}>
            <Chip label={currentlySelectedSlot} sx={{ borderRadius: "6px" }} />
            <Chip
              label={`(${moment
                .tz(sessionData?.selectedTimezone ?? moment.tz.guess())
                .locale(selectedLanguageForMoment)
                .format("Z")}) ${sessionData?.selectedTimezone}`}
              sx={{ borderRadius: "6px" }}
            />
          </Stack>
        </Stack>
        <BookingFormWrapper
          meetingLink={meetingLink}
          sessionData={sessionData}
          handleFormInput={handleFormInput}
          actions={actions}
          ui={ui}
        />
      </DialogContent>
    </Dialog>
  );
};
